module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.88f0b869.mp3";